import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';

import { User } from '~/auth/model/user';
import { VtmnPlayIconButtonSizeEnum } from '~/component/buttons/vtmn-play-icon-button/enum/vtmn-play-icon-button-size.enum';
import { VtmnPlayIconButtonVariantEnum } from '~/component/buttons/vtmn-play-icon-button/enum/vtmn-play-icon-button-variant.enum';
import { CtaButtonTypeEnum } from '~/component/call-to-action/enums/button-type.enum';
import { HeaderVariantEnum } from '~/component/header/enums/variant.enum';
import { MenuItemInterface } from '~/component/header/login/menu/interfaces/menu-item.interface';
import { VtmnPlayIconTypeEnum } from '~/component/vtmn-play-icon/enums/vtmn-play-icon-type.enum';
import { generateUid } from '~/core/helpers/uid/uid.helper';

@Component({
  selector: 'app-header-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class HeaderLoginComponent {
  @Input() public menuItems: MenuItemInterface[][] = [];
  @Input() public user: User;
  @Input() public variant = HeaderVariantEnum.Attendee;

  @Output() public readonly clicked = new EventEmitter();

  public readonly ctaButtonType = CtaButtonTypeEnum;
  public readonly loginId = generateUid();
  public readonly vtmnPlayIconButtonSize = VtmnPlayIconButtonSizeEnum;
  public readonly vtmnPlayIconButtonVariant = VtmnPlayIconButtonVariantEnum;

  public isOpen: boolean;

  constructor(private readonly elementRef: ElementRef) {}

  public get accountIcon(): VtmnPlayIconTypeEnum {
    return VtmnPlayIconTypeEnum.User;
  }

  public get buttonId(): string {
    return `button-${this.loginId}`;
  }

  public get isAuthenticated(): boolean {
    return Boolean(this.user);
  }

  public get menuIcon(): VtmnPlayIconTypeEnum {
    return this.isOpen ? VtmnPlayIconTypeEnum.Close : VtmnPlayIconTypeEnum.Menu;
  }

  public get menuId(): string {
    return `menu-${this.loginId}`;
  }

  public get variantClass(): string {
    return `header-login--${this.variant}`;
  }

  @HostListener('document:click', ['$event'])
  private clickout(event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }

  public onClick(): void {
    this.clicked.emit();
  }

  public toggleMenu(): void {
    this.isOpen = !this.isOpen;
  }
}
